// extracted by mini-css-extract-plugin
export default {"points-balance-error":"styles_points-balance-error__N2+nw"};